import { FC, ReactElement } from 'react';

import { Button } from '../../../components';
import trans from '../../../helpers/trans';
import { ButtonList } from '../..';

import './ConfirmDeleteActionButtons.scss';

interface ConfirmDeleteActionButtonsProps {
    submitText?: string;
    onConfirmClick: () => void;
    onCancelClick: () => void;
    className?: string;
}

const ConfirmDeleteActionButtons: FC<ConfirmDeleteActionButtonsProps> = ({
    submitText = trans('common.delete'),
    onConfirmClick,
    onCancelClick,
    className = '',
}): ReactElement => (
    <ButtonList className={`confirm-delete-action-buttons ${className}`}>
        <Button
            text={submitText}
            onClick={onConfirmClick}
            className="confirm-delete-action-buttons__button--confirm"
        />
        <Button
            text={trans('common.cancel')}
            onClick={onCancelClick}
            className="confirm-delete-action-buttons__button--cancel"
        />
    </ButtonList>
);

export default ConfirmDeleteActionButtons;
